import * as React from 'react';
import { useTheme } from 'styled-components';

import { Bin } from 'common/icons';
import { PK } from 'common/types';
import { Menu } from 'common/components/DropdownMenu';
import { toastMessages } from 'common/toastMessages';
import { useToast } from 'modules/toast';

import { useRecipeDelete } from '../queries';

interface MenuProps {
  pk: PK;
}

const RecipesMenu = ({ pk }: MenuProps) => {
  const theme = useTheme();
  const { toast } = useToast();
  const { mutate: removeRecipe, isLoading, isError } = useRecipeDelete();

  const handleDelete = () => {
    removeRecipe(
      { pk },
      {
        onSuccess: () => {
          toast(toastMessages.SUCCESS.GENERIC_SUCCESS, 'success');
        },
        onError: (error) => {
          toast(error.message, 'error');
        },
      },
    );
  };

  const menuItems = [
    {
      isError,
      isLoading,
      label: 'Delete',
      icon: (
        <Bin color={theme.keys.secondaryColor} hoverColor={theme.keys.secondaryColor} />
      ),
      onClick: handleDelete,
    },
  ];

  return <Menu menuItems={menuItems} />;
};

export default RecipesMenu;
